import { useEffect } from 'react';

import HuddleIframe from './components/HuddleIframe';
import {
  ClientConfigSchema,
  IColorScheme,
  TClientConfig,
  THuddleEvents,
  THuddleEventsMap,
  TReaction,
} from './types';
import { sendDataToIframe, zodErrHandler } from './utils';

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

const iframeApi = {
  initialize: zodErrHandler(async (eventData: TClientConfig) => {
    ClientConfigSchema.parse(eventData);

    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'initialize',
      eventData,
    });
  }),
  muteMic: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'muteMic',
    });
  },
  unmuteMic: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'unmuteMic',
    });
  },
  enableWebcam: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'enableWebcam',
    });
  },
  disableWebcam: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'disableWebcam',
    });
  },
  enableShare: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'enableShare',
    });
  },
  disableShare: async () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'disableShare',
    });
  },
  changeAvatarUrl: (avatarUrl: string) => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'changeAvatarUrl',
      eventData: avatarUrl,
    });
  },
  sendReaction: (reaction: TReaction) => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'sendReaction',
      eventData: reaction,
    });
  },
  lockRoom: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'lockRoom',
    });
  },
  unlockRoom: () => {
    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'unlockRoom',
    });
  },
  connectWallet: (token: string) => {
    const parsedJWT = parseJwt(token);

    // console.log('connectWallet', { parsedJWT });

    sendDataToIframe({
      type: 'huddle01-iframe-from-parent',
      method: 'connectWallet',
      eventData: { token, parsedJWT },
    });
  },
  setTheme: (theme: IColorScheme) => {
    sendDataToIframe({
      method: 'theme',
      type: 'huddle01-iframe-from-parent',
      eventData: theme,
    });
  },
  // on: (huddleEvent: THuddleEvents, cb: (data?: any) => void) => {
  //   window.onmessage = (event: MessageEvent<any>) => {
  // if (event.data.eventData.event !== huddleEvent) return;
  //     console.log('onmessage', event.data.eventData);
  //     cb?.();
  //   };
  // },
};

const useEventListner = <K extends THuddleEvents>(
  huddleEvent: K,
  cb: (data: THuddleEventsMap[K][0]) => void,
  dep?: unknown[],
) => {
  useEffect(
    () => {
      const handleIframe = (
        // biome-ignore lint/suspicious/noExplicitAny: TODO
        event: MessageEvent<{
          eventData: { data?: any; event: THuddleEvents };
        }>,
      ) => {
        if (!event || event?.data.eventData?.event !== huddleEvent) return;
        cb(event.data.eventData.data);
      };

      window.addEventListener('message', handleIframe);

      return () => {
        window.removeEventListener('message', handleIframe);
      };
    },
    dep ? [dep] : [],
  );
};

export { HuddleIframe, iframeApi, useEventListner };
